import { useEffect } from 'react';

const TikTokPixel = ({ pixelId }) => {
  useEffect(() => {
    if (!pixelId) return;

    window.ttq = window.ttq || [];
    const ttq = window.ttq;
    if (ttq._initialized) return;

    ttq.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie'];
    ttq.setAndDefer = (target, method) => {
      target[method] = (...args) => target.push([method, ...args]);
    };
    for (let index = 0; index < ttq.methods.length; index += 1) {
      ttq.setAndDefer(ttq, ttq.methods[index]);
    }

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://analytics.tiktok.com/i18n/pixel/events.js?sdkid=' + encodeURIComponent(pixelId) + '&lib=ttq';
    document.head.appendChild(script);

    ttq._initialized = true;
    ttq.load = ttq.load || (() => {});
    ttq.page();

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
      delete window.ttq;
    };
  }, [pixelId]);

  return null;
};

export default TikTokPixel;
